// This variable will hold the reference to
// document's click handler
let handleOutsideClick;
let addStartCoors;
let startX;
let startY;
const delta = 6;

export default {
    bind(el, binding, vnode) {
        const {
            timeout
        } = binding.value

        if(!binding.value) {
            return;
        }

        setTimeout(() => {
            // Here's the click/touchstart handler
            // (it is registered below)
            handleOutsideClick = (e) => {          
                e.stopPropagation()
                // Get the handler method name and the exclude array
                // from the object used in v-closable
                const {
                    handler,
                    exclude
                } = binding.value
    
                // This variable indicates if the clicked element is excluded
                let clickedOnExcludedEl = false
                exclude.forEach(className => {
                    // We only run this code if we haven't detected
                    // any excluded element yet
                    if (!clickedOnExcludedEl) {
                        if(e.target.parentElement !== null && e.target.parentElement.classList) {
                            clickedOnExcludedEl = e.target.parentElement.classList.contains(className);
                        }
    
                        if(!clickedOnExcludedEl && e.target.classList) {
                            clickedOnExcludedEl = e.target.classList.contains(className);
                        }
                    }
                })
                const diffX = Math.abs(e.pageX - startX);
                const diffY = Math.abs(e.pageY - startY);

                let wasClicked = diffX < delta && diffY < delta;
                
                // We check to see if the clicked element is not
                // the dialog element and not excluded
                if (!el.contains(e.target) && !clickedOnExcludedEl && wasClicked) {
                    // If the clicked element is outside the dialog
                    // and not the button, then call the outside-click handler
                    // from the same component this directive is used in
                    vnode.context[handler]()
                }
            }

            addStartCoors = (event) => {
                startX = event.pageX;
                startY = event.pageY;
            }

            document.addEventListener('click', handleOutsideClick);
            document.addEventListener('mousedown', addStartCoors);
        }, timeout);
    },

    addStartCoors(event) {
    },

    unbind() {
        // If the element that has v-closable is removed, then
        // unbind click/touchstart listeners from the whole page
        document.removeEventListener('click', handleOutsideClick)
        document.removeEventListener('mousedown', addStartCoors)
    }
}